<template>
    <div>
        <div v-if="isLoggedIn">
            <v-list-item>
                <v-list-item-avatar>
                    <v-img src="https://randomuser.me/api/portraits/men/1.jpg"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>Guillaume Pineda</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <template v-for="(item, index) in items">

                    <v-divider v-if="item.divider" :key="index" :inset="item.inset"></v-divider>
                    <v-list-item v-else :key="item.title" link :to="item.url">
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </div>

        <div v-else>
            <a href="#/login">Loggin before</a>
        </div>

    </div>

</template>

<script>
    export default {
        name: 'SideMenu',

        data() {
            return {
                items: [
                    { title: 'Dashboard', icon: 'mdi-monitor-dashboard' },
                    { title: 'RH', icon: 'mdi-account-group-outline', url: '/humanResources' },
                    { title: 'Documents', icon: 'mdi-file-multiple', url: "/document" },
                    { title: 'Taches', icon: 'mdi-calendar-check' },
                    { divider: true, inset: false },
                    { title: 'Mon compte', icon: 'mdi-account' },
                    { title: 'Logout', icon: 'mdi-account', url: "/logout" },

                ],
                mini: true,

            }
        },
        computed: {

                isLoggedIn: function() {
                    return this.$store.state.auth.status.loggedIn;
                }



        }
    }


</script>
